import React, { useEffect, useState } from 'react';
import { adminAPI } from '../../../services/authService';
import { notifyError } from '../../../utils/notify';

const ConfigAuditLog = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    adminAPI.getConfigAudit()
      .then((res) => setRows(res?.data?.data || res?.data || []))
      .catch(() => notifyError('Unable to load configuration audit log'));
  }, []);
  return (
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>When</th><th>Actor</th><th>Action</th><th>Target</th><th>Summary</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr><td colSpan={5} style={{ textAlign: 'center', color: '#64748b', padding: 24 }}>No audit entries</td></tr>
          ) : rows.map((r) => (
            <tr key={r.id}>
              <td>{r.createdAt ? new Date(r.createdAt).toLocaleString('en-IN') : '—'}</td>
              <td>{r.actorEmail || r.actorName || 'system'}</td>
              <td>{r.action}</td>
              <td>{r.targetType}{r.targetKey ? `:${r.targetKey}` : ''}</td>
              <td>{r.changeSummary || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ConfigAuditLog;
